/**
 * @file Web Galleries Album related fragments.
 */

import gql from 'graphql-tag';

import {
  AlbumRootAlbumFolderBaseDetails,
  PhotoUrlTypeFields,
} from '../../../../graphql/fragments/album';

export const WebGalleryAlbumBaseDetails = gql`
  fragment WebGalleryAlbumBaseDetails on Album {
    id
    name
    privacy
    join_code
    display_name
    album_type
    album_subtype
    hash_code
    last_uploaded_at
    is_web_gallery
    is_private_web_gallery
    download_without_watermark
    download_without_purchase
    print_without_watermark
    social_share_enabled
    is_demo
    pre_paid: is_demo
    web_gallery_print_purchases_enabled
    search_subscription_credits_joins_enabled
    web_gallery_price_per_photo {
      value
      currency
    }
    display_public_photo_attribution
    start_date
    end_date
    is_video_album
    joins_enabled
  }
`;

export const WebGalleryAlbumPurchasedPhotoDownloads = gql`
  fragment WebGalleryAlbumPurchasedPhotoDownloads on Album {
    id
    purchased_photo_downloads(slice: { limit: 9999 }) {
      records {
        photo {
          id
        }
      }
    }
  }
`;

export const WebGalleryAlbumPrices = gql`
  fragment WebGalleryAlbumPrices on Album {
    id
    is_demo
    enforce_pricing_tag_digital_downloads
    price_whole_album {
      value
      currency
    }
    photo_pricing {
      id
    }
    album_print_packages {
      total
    }
  }
`;

export const WebGalleryAlbumListingDetails = gql`
  fragment WebGalleryAlbumListingDetails on Album {
    id
    name
    display_name
    is_demo
    album_type
    album_subtype
    last_uploaded_at
    join_code
    privacy
    cover_photo {
      id
      faces_box
      thumbnail_urls(ignore_watermark: true) {
        ...PhotoUrlTypeFields
      }
    }
    album_folder {
      id
    }
    enable_external_upload
    auto_contributor_share_url
    purchased_event_addon_types
    ...WebGalleryAlbumPrices
  }
  ${PhotoUrlTypeFields}
  ${WebGalleryAlbumPrices}
`;

export const WebGalleryAlbumCustomPrintFields = gql`
  fragment WebGalleryAlbumCustomPrintFields on Album {
    id
    custom_prints_meta(custom_print_types: [WALDOGRAM]) {
      onsite_delivery_enabled
      offsite_shipping_enabled
    }
    collages: custom_prints(custom_print_types: [COLLAGE]) {
      total
    }
  }
`;

export const WebGalleryAlbumAccessFields = gql`
  fragment WebGalleryAlbumAccessFields on Album {
    id
    has_password
    invite_only_access
    contributor_access {
      upload_access
      view_access
    }
    ...AlbumRootAlbumFolderBaseDetails
  }
  ${AlbumRootAlbumFolderBaseDetails}
`;
